import Can, {CanWithRole, getUserRoles, hasPermission} from './Can'
import PrivateRoute from './PrivateRoute'

export * from 'constants/permissions'
export {CanWithRole, PrivateRoute, getUserRoles, hasPermission}
export default Can
